import axios from "axios";
import { SAVE_BOOKING, SAVE_FLIGHT_BOOKING, BASE_URL, MAKE_PAYMENT_SESSION, COMMON_BASE_URL, GET_MARKUP_SETTINGS } from "../utils/constantAPI";
import { handleErrorResponseAxios, handleResponseAxios } from "./commonHandler";

export async function saveBooking(values,onSuccess,onError){
    var url = SAVE_BOOKING;
    let axiosConfig = {
        headers: {
            "Content-Type": "application/json"
        },
    };

    try {
        let response = await axios.post(url, values, axiosConfig);
        onSuccess(handleResponseAxios(response));
    } catch (error) {
        onError(handleErrorResponseAxios(error));
    }
}

export async function saveFlightBooking(values,onSuccess,onError){
    var url = SAVE_FLIGHT_BOOKING;
    let axiosConfig = {
        headers: {
            "Content-Type": "application/json"
        },
    };

    try {
        let response = await axios.post(url, values, axiosConfig);
        onSuccess(handleResponseAxios(response));
    } catch (error) {
        onError(handleErrorResponseAxios(error));
    }
}

export const searchFlights = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/searchFlights`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const searchTwoWayFlights = async (data, onSuccess, onError) => {    
    try {
        const response = await axios.post(`${BASE_URL}/searchFlights`, data, {
            headers: { "Content-Type": "application/json" },
        });
        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const flightPriceCheck = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/priceCheck`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const flightFareRules = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/flightFareRules`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
export const flightExtraServices = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/flightExtraServices`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
export const createFlightBooking = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/createFlightBooking`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export async function makePaymentSession(values,onSuccess,onError){
    var url = MAKE_PAYMENT_SESSION;
    let axiosConfig = {
        headers: {
            "Content-Type": "application/json"
        },
    };

    try {
        let response = await axios.post(url, values, axiosConfig);
        onSuccess(handleResponseAxios(response));
    } catch (error) {
        onError(handleErrorResponseAxios(error));
    }
}
export const getCurrencyRate = async (from = "MYR", to = "USD") => {
    if (from === to) return 1;

    try {
        const response = await axios.get(
            `https://api.frankfurter.app/latest?from=${from}&to=${to}`
        );
        return response.data.rates[to];
    } catch (error) {
        console.error("Currency rate fetch error:", error);
        return 1;
    }
};

export const convertCurrency = async (amount, from="MYR" , to="GBP" ) => {
    if (from === to) return amount;
  
    try {
      const response = await axios.get(
        `https://api.frankfurter.app/latest?amount=${amount}&from=${from}&to=${to}`
      );
      return response.data.rates[to];
    } catch (error) {
      console.error("Currency conversion error:", error);
      return amount; // fallback to original amount
    }
  };
export const getSupportedCurrencies = async () => {
    try {
        const res = await axios.get("https://api.frankfurter.app/currencies");
        return res.data; 
    } catch (err) {
        console.error("Error fetching currencies", err);
        return {}; 
    }
};
export const detectCurrencyByIP = async () => {
    try {
        const res = await axios.get("https://ipapi.co/json/");
        return res.data.currency || "MYR";
    } catch (err) {
        console.error("GeoIP detection error:", err);
        return "MYR";
    }
  };

  export const saveUserBookingDetails = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${COMMON_BASE_URL}/saveUserDetails`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const convertToUSD = async (amount, fromCurrency) => {
  if (fromCurrency === 'USD') return amount;
  
  try {
    // Use a real exchange rate API
    const response = await axios.get(`https://api.exchangerate-api.com/v4/latest/USD`);
    const rate = response.data.rates[fromCurrency];
    
    if (!rate) throw new Error('Currency not supported');
    
    return amount / rate;
  } catch (error) {
    console.error('Currency conversion error:', error);
    throw error;
  }
};
//getFlightBookingById
// export const getFlightBookingById = async (id, onSuccess, onError) =>
//     {
//         try {
//             const response = await axios.get(`${COMMON_BASE_URL}/flight/getFlightBookingById/?bookingId=${id}`, {
//                 headers: { "Content-Type": "application/json" },
//             });
//             if (onSuccess) onSuccess(response.data);
//         }
//         catch (error) {
//             if (onError) onError(error);
//         }
// }
export const getFlightBookingById = (bookingId, email, onSuccess, onError) => {
  return axios
    .get(`${COMMON_BASE_URL}/flight/getFlightBookingById`, {
      params: { bookingId, email },
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      if (onSuccess) onSuccess(response.data);
      return response;
    })
    .catch((error) => {
      if (onError) onError(error);
      throw error; 
    });
};


export const directFlightBooking = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/createDirectTicket`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const sendOTP = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/send-otp`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};

export const validateOTP = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/validate-otp`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
export const confirmationEmail = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/send-initial-email`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
// Add this to your existing services.js
export const sendModificationRequest = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/flight-modify-request`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
export const changeRequest = async (data, onSuccess, onError) => {
    try {
        const response = await axios.post(`${BASE_URL}/request-flight-change`, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (onSuccess) onSuccess(response.data);
    } catch (error) {
        if (onError) onError(error);
    }
};
export const getAirlineLogoUrl = (iataCode) => {
  if (!iataCode) return ""; 
  return `https://content.airhex.com/content/logos/airlines_${iataCode}_350_100_r.png`;
};

export async function getMarkupSettings( onSuccess, onError) {
  const url = GET_MARKUP_SETTINGS;

  let axiosConfig = {
    headers: {
      "Content-Type": "application/json"
    },
  };

  try {
    let response = await axios.get(url, axiosConfig);
    onSuccess(handleResponseAxios(response));
  } catch (error) {
    onError(handleErrorResponseAxios(error));
  }
}